export default __webpack_public_path__ + "static/media/project12.76fafa56.PNG";